/* Chad's Raspberry Kitchen - crk-app.js (Flow theme integration)
   Buy box: radio cards map to a native product form. The Subscribe card
   enables the selling_plan <select>; One-time disables it so it is not posted. */
(function () {
  "use strict";
  var box = document.querySelector("[data-buybox]");
  if (!box) return;
  var cta = box.querySelector("[data-cta]");
  var freqSelect = box.querySelector("[data-frequency]");
  var radios = box.querySelectorAll('input[name="purchase_type"]');
  var render = function () {
    var checked = box.querySelector('input[name="purchase_type"]:checked');
    var isSub = !!(checked && checked.value === "subscribe");
    if (freqSelect) freqSelect.disabled = !isSub;
    if (cta && !cta.disabled) {
      if (isSub && freqSelect) {
        var opt = freqSelect.options[freqSelect.selectedIndex];
        cta.textContent = "Subscribe Now — " + (opt.getAttribute("data-price") || "") + (opt.getAttribute("data-suffix") || "");
      } else {
        cta.textContent = "Add to Cart — " + (box.getAttribute("data-onetime-price") || "");
      }
    }
  };
  for (var i = 0; i < radios.length; i++) radios[i].addEventListener("change", render);
  if (freqSelect) freqSelect.addEventListener("change", render);
  render();
})();
/* PDP v2 */
(function () {
  "use strict";
  var root = document.querySelector("[data-pdp2]");
  if (!root) return;
  var stage = root.querySelector("[data-stage-img]");
  var thumbs = root.querySelectorAll("[data-thumb]");
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener("click", function () {
      if (!stage) return;
      stage.src = t.getAttribute("data-src");
      stage.srcset = t.getAttribute("data-srcset") || "";
      stage.alt = t.getAttribute("data-alt") || "";
      Array.prototype.forEach.call(thumbs, function (x) { x.setAttribute("aria-pressed", "false"); });
      t.setAttribute("aria-pressed", "true");
    });
  });
  var typeRadios = root.querySelectorAll('input[name="purchase_type"]');
  var planRadios = root.querySelectorAll('input[name="selling_plan"]');
  var cta = root.querySelector("[data-cta]");
  var stickyPrice = root.querySelector("[data-sticky-price]");
  var stickyCta = root.querySelector("[data-sticky-cta]");
  var render = function () {
    var checked = root.querySelector('input[name="purchase_type"]:checked');
    var isSub = !!(checked && checked.value === "subscribe");
    Array.prototype.forEach.call(planRadios, function (r) { r.disabled = !isSub; });
    root.classList.toggle("is-onetime", !isSub);
    var price = root.getAttribute("data-onetime-price") || "";
    if (isSub) {
      var p = root.querySelector('input[name="selling_plan"]:checked');
      price = (p && p.getAttribute("data-price")) || root.getAttribute("data-sub-price") || price;
      var disp = root.querySelector("[data-sub-display]");
      if (disp) disp.textContent = price;
    }
    if (cta && !cta.disabled) cta.textContent = (isSub ? "Subscribe \u00b7 " : "Add to cart \u00b7 ") + price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (stickyCta) stickyCta.textContent = isSub ? "Subscribe" : "Add to cart";
  };
  Array.prototype.forEach.call(typeRadios, function (r) { r.addEventListener("change", render); });
  Array.prototype.forEach.call(planRadios, function (r) { r.addEventListener("change", render); });
  render();
  var qty = root.querySelector("[data-qty]");
  if (qty) {
    var input = qty.querySelector("input");
    var step = function (d) { var n = parseInt(input.value, 10) || 1; n = Math.max(1, n + d); input.value = n; };
    qty.querySelector("[data-qty-dec]").addEventListener("click", function () { step(-1); });
    qty.querySelector("[data-qty-inc]").addEventListener("click", function () { step(1); });
  }
  var sticky = root.querySelector("[data-sticky]");
  if (sticky && cta && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle("is-visible", past);
      sticky.setAttribute("aria-hidden", past ? "false" : "true");
    }, { threshold: 0 });
    io.observe(cta);
  }
})();
